export default class WindowStateChecker {
  constructor() {
    this.browserWindowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    }

    this.init()
  }

  init() {
    this._addEventListeners()
  }

  destroy() {
    this._removeEventListeners()
  }

  _addEventListeners() {
    window.addEventListener('focus', this.onFocus, false)
    window.addEventListener('blur', this.onBlur, false)
    window.addEventListener('resize', this.onResize, false)
  }

  _removeEventListeners() {
    window.removeEventListener('focus', this.onFocus)
    window.removeEventListener('blur', this.onBlur)
    window.removeEventListener('resize', this.onResize)
  }

  onFocus = () => {
    const isWidthSame = this.browserWindowSize.width !== window.innerWidth;
    const isHeightSame = this.browserWindowSize.height !== window.innerHeight;

    if (isWidthSame || isHeightSame) {
      location.reload()
    }

    this.browserWindowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  onBlur = () => {}

  onResize = () => {
    this.browserWindowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }
}
